import { HeartHand } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "recognition",
  priority: 2,
  icon: HeartHand,
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("Recognition", { ns: "recognition.shared" }),
        icon: <HeartHand />,
        child: [
          {
            label: t("Period Reports", { ns: "recognition.admin" }),
            to: "/admin/recognition/period-reports",
            permission: "recognition.recognition-period.view",
          },
          {
            label: t("Appreciation criteria", { ns: "recognition.shared" }),
            to: "/admin/recognition/values",
            permission: "recognition.recognition-value.view",
          },
          {
            label: t("Periods", { ns: "recognition.admin" }),
            to: "/admin/recognition/periods",
            permission: "recognition.recognition-period.view",
          },
          {
            label: t("Rewards", { ns: "recognition.shared" }),
            to: "/admin/recognition/rewards",
            permission: "recognition.recognition-reward.view",
          },
          {
            label: t("Rewards Report", { ns: "recognition.admin" }),
            to: "/admin/recognition/transactions/rewards",
            permission: "recognition.recognition-transaction-reward.view",
          },
        ],
      },
    ],
    settings: [
      {
        label: t("Recognition", { ns: "recognition.shared" }),
        icon: <HeartHand />,
        to: "/admin/settings/recognition",
        permission: "recognition.recognition-settings.view",
      },
    ],
  }),
} satisfies ModuleData;
